import React, { useContext } from "react";
import styles from "./DmitryScheme.module.scss";
import PathContext from "../../context/path";
const DmitryScheme = () => {
  const path = useContext(PathContext);
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.title}>Главная сложность — производство второго компонента</div>
        <div className={styles.text}>Оба компонента вакцины от ковида содержат вирус, лишенный гена размножения, или так называемый вирусный вектор</div>
        <div className={styles.row}>
          <div className={styles.col}>
            <div className={styles.img}>
              <picture>
                <source media="screen and (max-width: 767px)" srcSet={`${path}/img/dmitry-scheme-mobile.webp`} />
                <img src={`${path}/img/dmitry-scheme.webp`} alt="" />
              </picture>
            </div>
          </div>
          <div className={styles.col}>
            <div className={styles.texts}>
              <div className={styles.text}>Первый компонент вакцины содержит вектор на основе аденовируса человека 26-го серотипа <span>(AD-26)</span></div>
              <div className={styles.text}>
              Второй — рекомбинантный аденовирусный вектор на основе аденовируса человека 5-го серотипа <span>(AD-5)</span>
                <svg width="57" height="37" viewBox="0 0 57 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M53.8791 15.8485L52.1709 8.40279C32.7654 36.4282 1.00086 22.1716 1.00086 22.1716" stroke="#98ACF9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M44.6118 9.72324L52.1678 8.37703" stroke="#98ACF9" strokeWidth="2.00585" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

              </div>
            </div>
            <div className={styles.label}>
            Из-за того, что продуктивность второго компонента гораздо ниже, даже небольшое отклонение от процесса приводит к тому, что получить вакцину становится невозможно.
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default DmitryScheme;
